import CompanyLogo from "@/public/core/components/CompanyLogo";
import React from "react";
import { appStage } from "@/environment";
import styled from "styled-components";
import theme from "@/styles/theme";

const CompanyLogoContainer = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 0 ${theme.spacing.unit * 2}px;
  margin-top: auto;
`;

const LogoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const EnvLabel = styled.div`
  font-size: 8px;
  color: ${theme.colors.red};
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 0.5px;
  height: ${theme.spacing.unit * 2}px;
  display: flex;
  align-items: center;
`;

const SidebarCompanyLogo = ({ user }) => {
  // Show the company logo if this is dev or uat and they have a logo
  const shouldShowCompanyLogo =
    appStage !== "production" && user?.employerProfile?.brandingData?.logoUrl;

  if (!shouldShowCompanyLogo) {
    return null;
  }

  return (
    <CompanyLogoContainer>
      <LogoWrapper>
        <CompanyLogo
          logoUrl={user?.employerProfile?.brandingData?.logoUrl}
          employerProfile={user?.employerProfile}
          height={24}
        />
        <EnvLabel>{appStage}</EnvLabel>
      </LogoWrapper>
    </CompanyLogoContainer>
  );
};

export default SidebarCompanyLogo;
